import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TSP } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class PortalService {
  private readonly http = inject(HttpClient);

  public getPortals(
    query: TSP.Internal.Recruiter.Portal.Query,
  ): Observable<TSP.API.Helpers.EntitiesList<TSP.Internal.Recruiter.Portal.Details>> {
    return this.http.get<TSP.API.Helpers.EntitiesList<TSP.Internal.Recruiter.Portal.Details>>('/admin/portal', {
      params: { ...query },
    });
  }

  public getAllPortals(): Observable<TSP.API.Helpers.EntitiesList<TSP.Internal.Recruiter.Portal.Details>> {
    return this.http.get<TSP.API.Helpers.EntitiesList<TSP.Internal.Recruiter.Portal.Details>>('/admin/portal', {
      params: { page: 0, size: 1000, sortBy: 'name', sortOrder: 'asc', search: '' },
    });
  }

  public createPortal(
    portal: TSP.Internal.Recruiter.Portal.CreatePayload,
  ): Observable<TSP.Internal.Recruiter.Portal.Details> {
    return this.http.post<TSP.Internal.Recruiter.Portal.Details>('/admin/portal', portal);
  }

  public updatePortal(
    portal: TSP.Internal.Recruiter.Portal.UpdatePayload,
  ): Observable<TSP.Internal.Recruiter.Portal.Details> {
    return this.http.put<TSP.Internal.Recruiter.Portal.Details>(`/admin/portal/${portal.id}`, portal);
  }

  public deletePortal(id: number): Observable<TSP.API.Helpers.BooleanResponse> {
    return this.http.delete<TSP.API.Helpers.BooleanResponse>(`/admin/portal/${id}`);
  }
}
